<template>
  <v-container fluid class="inventorycount-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <!-- <v-btn to="/inventorycount/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn> -->
              <v-btn color="success" class="button-shadow mr-3" @click="isFindCount=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn to="/inventory/list" color="default" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Inventory
              </v-btn>
              <!-- <download-excel
                class="btn btn-default"
                :data="getJson()"
                worksheet="My Worksheet"
                type="xls"
                :name="getFileName()"
              >
              <v-btn 
                v-show="counts_data.length>0"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
              >
                <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
                Save
              </v-btn>
              </download-excel> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              show-select
              sort-desc
              item-key="_id"
              v-model="dataSelected"
              loading-text="Loading... Please wait"
              class="inventorycounts-table"
              sort-by="countnum"
              :loading="isReceiving || isDeleting"
              :footer-props="footer"
              :headers="itemHeaders"
              :items="counts_data"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteCount"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Inventory Count?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_count.countnum }} 
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteCount = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteCount(delete_count)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:5px">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.countimage="{ item }">
                    <v-img
                    v-if="item.countimage" 
                    v-bind:src="item.countimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.countnum="{ item }">
                <p class="two-line">{{ item.counttype  }}</p>
                <p class="two-line">{{ item.countnum  }}</p>
                <p v-if="item.countdate!=undefined" class="two-line">{{ new Date(item.countdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.counttotal="{ item }">
                <p class="two-line">{{ item.counttotal.toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.transactions="{ item }">
                {{ item.transactions.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.itemquantity * tran.itemcost),0).toFixed(2) }}
              </template>
              <template v-slot:item.countstatus="{ item }">
                <v-chip
                  v-if="item.countstatus!=undefined"
                  :color="item.countstatus=='Completed' ? 'successConst white--text' : item.countstatus=='Partial' ? 'warning white--text' : 'secondaryConst white--text'" small>
                  {{ item.countstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <div v-if="item._id!=undefined">
                <!-- <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                <!-- <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn> -->
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.countstatus!=='Completed'" icon color="primary" @click="deleteCountDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isFindCount"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Find InventoryCounts</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-select
                    :items="users.filter(x=>x.userstatus=='Active').map(x => {
                              return {text: x.username, value: x._id};
                            })"
                    v-model="find_query.userid"
                    label="Sales Rep"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_startdate"
                    v-model="menu_startdate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.startdate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="find_query.startdate"
                        label="Start Date"
                        v-bind="attrs"
                        v-bind:value="find_query.startdate"
                        v-on="on"
                        persistent-hint
                        single-line hint="Please enter start date">
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="find_query.startdate"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="menu_startdate = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.menu_startdate.save(find_query.startdate)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-menu
                    ref="menu_enddate"
                    v-model="menu_enddate"
                    :close-on-content-click="false"
                    :return-value.sync="find_query.enddate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="find_query.enddate"
                      label="End Date"
                      v-bind="attrs"
                      v-bind:value="find_query.enddate"
                      v-on="on"
                      persistent-hint
                      single-line hint="Please enter end date">
                    ></v-text-field>
                  </template>
                  <v-date-picker
                              v-model="find_query.enddate"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu_enddate = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu_enddate.save(find_query.enddate)"
                              >
                                OK
                              </v-btn>
                      </v-date-picker>
                    </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isFindCount = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="resetInventoryCounts"
            >
              Reset
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="findInventoryCounts"
            >
              Find
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'InventoryCountList',
  data() {
    return {
      config,
      snackbar: null,
      isDeleteCount: false,
      dialogAlert: false,
      dialogMessage: '',
      isFindCount: false,
      menu_startdate: null,
      menu_enddate: null,
      itemPerPage: 500,
      delete_count: {},
      find_query: {},
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemHeaders: [
        { text: 'Image', value: 'countimage', sortable: false, width: '8%' },
        { text: 'Count', value: 'countnum' },
        { text: 'Location', value: 'locationid', width: '15%' },
        { text: 'Count By', value: 'userid', width: '15%' },
        { text: 'Count', value: 'counttotal', width: '10%' },
        { text: 'Value', value: 'transactions', width: '10%' },
        { text: 'Status', value: 'countstatus', width: '8%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%'},
      ],
      counts_data: [],
      dataSelected: [],

    }
  },
  computed: {
    ...mapState('InventoryCount', ['counts', 'isReceiving', 'isDeleting','inventorycountsMessage']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('InventoryCount', ["getInventoryCountsRequest", "getInventoryCountQueryRequest", "deleteInventoryCountRequest","updateInventoryCountRequest","createInventoryCountRequest"]),
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    getJson(){
      let json = this.counts.map(order=>{return {
        ordernum: order.countnum, 
        orderdate: order.countdate!=undefined ? new Date(order.countdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '',
        ordertime: order.countdate!=undefined ? new Date(order.countdate).toLocaleString("en-SG", { hour: 'numeric', minute: 'numeric' }) : '',
        ordertype: order.counttype,
        name: order.inventorycountname, 
        address: order.inventorycountaddress,
        region: order.regionid!=undefined && this.regions.length>0 ? this.regions.find(region=>region._id == order.regionid)['regionname'] : '',
        township: order.townshipid!=undefined && this.townships.length>0 ? this.townships.find(town=>town._id == order.townshipid)['townshipname'] : '',
        customertype: order.customertype,
        rep: order.userid!=undefined && this.users.length>0 ? this.users.find(user=>user._id == order.userid)['username'] : '',
        paymentmethod: order.paymethodid!=undefined && this.paymethods.length>0 ? this.paymethods.find(method=>method._id == order.paymethodid)['paymethodname'] : '',
        tax: order.inventorycounttaxamount,
        subtotal: order.inventorycountsubtotal,
        total: order.counttotal,
        rate: order.currencyRate,
      }});
      return json;
    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    editItem(item) {
      this.$router.push({ name: 'InventoryCountEdit', params: item });
    },
    printItem(item) {
      this.$router.push({ name: 'InventoryCountPrint', params: item });
    },
    viewItem(item) {
      this.$router.push({ name: 'InventoryCountView', params: item });
    },
    async findInventoryCounts(){
      this.isFindCount = false;
      if(this.find_query=={}){
        await this.getInventoryCountsRequest();
        this.counts_data = Object.assign([], this.counts);
      }
      else{
        let result = await this.getInventoryCountQueryRequest(this.find_query);
        this.counts_data = Object.assign([], result);
      }
    },
    async resetInventoryCounts(){
      this.find_query = {};
    },
    async deleteCount(item) {
      let result = await this.deleteInventoryCountRequest({_id: item._id});
      let index = this.counts_data.findIndex(count => count._id === result._id);
      this.counts_data.splice(index, 1);
      this.isDeleteCount = false;
    },
    deleteCountDialog(item) {
      this.isDeleteCount = true;
      this.delete_count = {
        _id: item._id,
        countnum: item.countnum,
      }
    },
  },
  async created () {
    if(this.counts.length==0) await this.getInventoryCountsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    this.counts_data = Object.assign([], this.counts);
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
